// @module TavanoTeam.CSExtensions.CSCertCaptureExt.NewCert.View
define('TavanoTeam.CSExtensions.CSCertCaptureExt.NewCert.View'
,	[
        'GlobalViews.Confirmation.View'
    ,   'Profile.Model'
    ,   'SC.Configuration'
        
    ,   'tavanoteam_csextensions_cscertcaptureext_newcert.tpl'

	,	'Utils'
	,	'Backbone'
	,	'jQuery'
	,	'underscore'
	]
,	function (
        GlobalViewsConfirmationView
    ,   ProfileModel
    ,   Configuration

	,   tavanoteam_csextensions_cscertcaptureext_newcert_tpl

	,	Utils
	,	Backbone
	,	jQuery
	,	_
	)
{
	'use strict';

	// @class TavanoTeam.CSExtensions.CSCertCaptureExt.NewCert.View @extends Backbone.View
	return Backbone.View.extend({

        template: tavanoteam_csextensions_cscertcaptureext_newcert_tpl

    ,	title: Utils.translate('Generate New Certificate')

	,	className: 'CertificatesNew'

    ,	page_header: Utils.translate('Generate New Certificate')

    ,   events: 
        {
            'click [name="load-certcapture-btn"]': 'loadAvalaraCertCapture'
        }

    ,   initialize: function(options)
        {
            this.options.application.getLayout().on('afterAppendView', this.loadCertCaptureScript(), this);
            this.ecomToken = options.model;

            this.profile = ProfileModel.getInstance();
        }

    ,   loadAvalaraCertCapture: function(e)
        {
            var certCaptureContainer = document.getElementById('certcapture-container')
            ,   self = this
            ,   user_address = this.profile.get('addresses')
            ,   userAddr = this.getDefaultShippingAddress(user_address)
            ,   userName = this.profile.get('name')
            ,   entityId = userName.substring(0, userName.indexOf(" "))
            ,   countries = Configuration.get('siteSettings.countries')
            ,   customer = {};

            //initialize CertCapture object
            GenCert.init(certCaptureContainer, {
                edit_purchaser: true
            ,   ship_zone: self.getStateName(userAddr.country, userAddr.state)
            ,   token: self.ecomToken.get('token')
            });

            //set customer's customer number (entityid from NS)
            GenCert.setCustomerNumber(entityId);

            //set customer information to autopopulate fields
            customer.name = this.profile.get('type') == 'COMPANY' ? this.profile.get('companyname') : this.profile.get('firstname') + " " + this.profile.get('lastname');
            customer.address1 = userAddr.addr1;
            customer.city = userAddr.city;
            customer.state = self.getStateName(userAddr.country, userAddr.state);
            customer.country = countries[userAddr.country].name;
            customer.zip = userAddr.zip;
            customer.phone = userAddr.phone;

            //send to CertCapture's ecommerce SDK
            GenCert.setCustomerData(customer);
            
            //show CertCapture's Wizard tool
            GenCert.show();
        }

    ,	loadCertCaptureScript: function()
		{
			var script = document.createElement('script')
			,	certCaptureScript = Configuration.get("certCapture.scriptURL");

			script.type = "text/javascript";
            script.src = certCaptureScript;

			jQuery("head").append(script);
        }

    ,   getDefaultShippingAddress: function(addresses)
        {
            var addressObj = {};

            addresses.map(function(state)
            {
                if(state.get('defaultshipping') == 'T')
                {
                    addressObj.state = state.get('state');
                    addressObj.addr1 = state.get('addr1');
                    addressObj.city = state.get('city');
                    addressObj.country = state.get('country');
                    addressObj.zip = state.get('zip');
                    addressObj.phone = state.get('phone');
                }
            });

            return addressObj;
        }

    ,   getStateName: function(countryCode, stateCode)
        {
            //Since SCA is returning the State's code instead of the whole name
            //We need to pull up the State's name as this is what is needed by CertCapture
            //to auto populate the state field
            var countries = Configuration.get('siteSettings.countries')
            ,   stateName = '';

            _.each(countries[countryCode].states, function(state)
            {
                if(state.code == stateCode)
                {
                    stateName = state.name;
                }
            });

            return stateName;
        }

    ,   hasNoDefaultShipping: function(address)
        {
            var hasNoDefault = true;

            address.map(function(res)
            {
                if(res.get('defaultshipping') == 'T')
                {
                    hasNoDefault = false;
                }
            });

            return hasNoDefault;
        }

		//@method getContext @return TavanoTeam.CSExtensions.CSCertCaptureExt.NewCert.View.Context
	,   getContext: function getContext()
		{
            var user_address = this.profile.get('addresses')
            ,   hasNoDefaultShipping = this.hasNoDefaultShipping(user_address);

			//@class TavanoTeam.CSExtensions.CSCertCaptureExt.NewCert.View.Context
			return {
                pageHeader: this.page_header
            ,   hasNoAddress: hasNoDefaultShipping
            };
		}
	});
});
